import { render, staticRenderFns } from "./TasksDueToday.vue?vue&type=template&id=270b90b2&scoped=true&"
import script from "./TasksDueToday.vue?vue&type=script&lang=js&"
export * from "./TasksDueToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b90b2",
  null
  
)

export default component.exports